<template>
  <div class="flex">
    <img
      :src="userInfo?.avatar  || getAva(message.sendUserId)"
      @error="imgOnError"
      class="personIcon"
    />
    <div class="infoContainer">
      <div class="titleInfo">
        <template v-if="message.sendUserId == systemNotice">
          <div class="userName">系统提示</div>
        </template>
        <template v-else-if="message.sendUserId?.indexOf('consultant_') >= 0">
          <div class="userName">{{userInfo?.name | desensitizedName}}</div>
        </template>
        <div class="userName" v-else>{{userInfo?.name || '--'}}</div>
        <div class="time">{{message.whenCreated}}</div>
      </div>
      <div class="messageContent">
        <template v-if="message.messageType=='TxtMsg'">
          <template v-if="message.messageExtra=='share'">
            <a
              :href="message.messageInfo.shareJson.shareUrl"
              target="_blank"
              title="点击查看"
              v-if="message.messageInfo.shareJson"
            >
              <h4 class="kldShareTitle">
                <strong>【链接】</strong>
                {{message.messageInfo.shareJson.name}}
              </h4>
            </a>
            <div v-else>
              <h4 class="kldShareTitle">
                <strong style="color:red;">无效的分享链接</strong>
              </h4>
            </div>
          </template>
          <div v-else v-html="message.messageInfo.content"></div>
          <div
            class="messageTip"
            v-if="message.messageExtra == 'auto' && message.sendUserId.indexOf('AI_ROBOT') >= 0"
          >！智能律师回复内容由AI技术提供，不代表平台提供者及系统开发者的观点，请酌情参考使用。</div>
        </template>

        <!-- <div v-html="message.messageInfo.content" v-if="message.messageType == 'TxtMsg'"></div> -->
        <template v-else-if="message.messageType == 'ImgMsg'">
          <template v-if="message.messageExtra=='emoji'">
            <img
              :src="message.messageInfo.imageUri"
              style="max-width:120px; height: auto; max-height: 200px;"
            />
          </template>
          <img
            :src="message.messageInfo.imageUri"
            @click="viewImg(message.messageInfo.imageUri)"
            class="pointer"
            mode="aspectFit"
            oncontextmenu="return false;"
            style="background: #fff;max-width:100%; height: auto; max-height: 200px"
            title="点击放大预览"
            v-else
          />
        </template>
        <template v-else-if="message.messageType == 'GIFMsg'">
          <img
            :src="message.messageInfo.remoteUrl"
            @click="viewImg(message.messageInfo.remoteUrl)"
            class="pointer"
            mode="aspectFit"
            oncontextmenu="return false;"
            style="background: #fff;max-width:100%; height: auto; max-height: 200px"
            title="点击放大预览"
          />
        </template>
        <template v-else-if="message.messageType == 'SightMsg'">
          <video
            :autoplay="false"
            :src="message.messageInfo.sightUrl"
            controls
            oncontextmenu="return false;"
            style="max-width:100%; height: auto; max-height: 200px"
          >您的浏览器不支持 video 标签。</video>
        </template>
        <template v-else-if="message.messageType == 'HQVCMsg'">
          <audio
            :autoplay="false"
            :src="message.messageInfo.sightUrl"
            controls
            oncontextmenu="return false;"
            style="max-width:100%; height: auto; max-height: 200px"
          >您的浏览器不支持 audio 标签。</audio>
        </template>
      </div>
    </div>
    <imgPreview :fileUrl="previewUrl" :show="showPreview" @close="closeP" v-if="showPreview" />
    <!--
    <Modal @on-cancel="closeP" footer-hide title="图片预览" v-model="showPreview" width="80vw">
      <div style="width: 100%; max-height:70vh; text-align: center; overflow:auto">
        <water-mark />
        <img :src="previewUrl" mode="aspectFit" />
      </div>
    </Modal>-->
  </div>
</template>
<script>
export default {
  props: {
    message: {},
    userInfo: {}
  },
  watch: {
    message: {
      handler (val) {
        if (val.messageType == 'TxtMsg' && val.messageExtra == 'share') {
          const htmlString = val.messageInfo?.content
          try {
            const jsonData = JSON.parse(htmlString)
            val.messageInfo.shareJson = jsonData
          } catch (error) {
            console.error('Error parsing JSON string:', error)
          }
        }
      },
      immediate: true,
    },
  },

  data () {
    return {
      previewUrl: '',
      showPreview: false
    }
  },
  computed: {
    systemNotice: function () {
      // 咨询人前缀
      return process.env.VUE_APP_IM_SYSTEM_USER_PRE + 'system_notice'
    },
  },
  methods: {
    getAva (sendUserId) {
      if (sendUserId == this.systemNotice) {
        return require('@/assets/static/images/system.jpg')
      } else if (sendUserId?.indexOf('consultant_') >= 0) {
        return require('@/assets/static/images/im/consultant@2x.png')
      } else if (sendUserId?.indexOf('AI_') >= 0) {
        return require('@/assets/static/images/im/robot.png')
      } else {
        return require('@/assets/static/images/im/lawyer@2x.png')
      }
    },
    closeP: function () {
      this.previewUrl = ''
      this.showPreview = false
    },
    viewImg: function (url) {
      this.previewUrl = url
      this.showPreview = true
    },
    imgOnError: function (e) {
      console.log('imgOnError', userInfo)
      if (this.userInfo.userId?.indexOf('consultant_') >= 0) {
        e.target.src = require('@/assets/static/images/im/consultant@2x.png')
        e.target.onerror = null
      } else {
        e.target.src = require('@/assets/static/images/im/lawyer@2x.png')
        e.target.onerror = null
      }
      // this.userInfo.
      // let img = e.srcElement

    },
  }
}
</script>
<style lang="less" scoped>
.allHisMessageItem {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #e8e9ec;

  .personIcon {
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 10px;
    background: white;
    border-radius: 50%;
    padding: 1px;
  }

  .infoContainer {
    flex-grow: 1;
    overflow: hidden;
    text-align: left;

    .titleInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .userName {
        color: #999;
        font-size: 12px;
        flex-grow: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .time {
        color: #999;
        font-size: 12px;
        white-space: nowrap;
      }
    }

    .messageContent {
      word-break: break-all;

      .messageTip {
        font-size: 12px;
        font-weight: 500;
        color: #999;
        border-top: 1px solid #e8eaec;
        padding-top: 2px;
      }
    }
  }
}
</style>
